module.exports = __webpack_public_path__ + "static/media/AEPS-Png.2da0ca39.png";